import { useMutation, useQueryClient } from '@tanstack/react-query';

import ApiCart from '@Api/Cart';
import { useDeps } from '@Contexts/DI';
import transformCart from './helpers/transformCart';
import useCartKeys from './useCartKeys';

import type { CartData } from '@Types/Cart';

export const useRemoveListFromCart = () => {
  const queryClient = useQueryClient();
  const keys = useCartKeys();
  const { analytics } = useDeps();

  return useMutation<CartData, Error, string[]>({
    mutationFn: async (positionsIds) => {
      const formatedData = positionsIds.map((positionId) => ({ cartPositionId: positionId }));
      const res = await ApiCart.remove(formatedData);

      return transformCart({ cart: res });
    },
    onSuccess: (cart, positionsIds) => {
      const removedPositions = queryClient
        .getQueryData<CartData>(keys)
        .positions.filter((position) => positionsIds.includes(position.id));

      queryClient.setQueryData(keys, (prev: CartData) => ({ ...prev, ...cart }));
      queryClient.invalidateQueries({ queryKey: ['cartShortInfo'], refetchType: 'all' });

      analytics.dispatchEvent('cart.remove', {
        products: removedPositions.flatMap((position) => position.products),
        label: 'Удаление выбранного',
      });
    },
  });
};

export default useRemoveListFromCart;
